export enum AssignmentType {
    None = 0,
    Online = 1,
    Regular = 2,
}
